module.exports = __webpack_public_path__ + "media/images/banner_fanclub-f18bf0a3fccef5fdfa319a5e40c32383.png";